import regionsService from '../../services/regionsService'

class RegionsController {
  fetchRegions = regionsService.fetchRegions
}

export default new RegionsController()
 


// WEBPACK FOOTER //
// ../src/controllers/regionsController/regionsController.js